module.exports = __webpack_public_path__ + "DINNextLTPro-MediumCond.woff2?b1b4e290b4ad8de0a3012e9e1a0fe7d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumCond.woff2
// module id = 1442
// module chunks = 0